var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"money"},[_vm._v("￥"+_vm._s(_vm.formatMoney))])])}
var staticRenderFns = []

export { render, staticRenderFns }